module.exports = __webpack_public_path__ + "img/1.79716140.jpg";